import { render, staticRenderFns } from "./TourArrival.vue?vue&type=template&id=46dcecdc&"
import script from "./TourArrival.vue?vue&type=script&lang=js&"
export * from "./TourArrival.vue?vue&type=script&lang=js&"
import style0 from "./TourArrival.vue?vue&type=style&index=0&id=46dcecdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports